<template>
  <div class="paperDetail">
    <exam-header :showDetail="true"></exam-header>
    <div v-if="userExam?.examDescription" class="paperDetail-desc">试卷说明：{{ userExam.examDescription }}</div>
    <div class="main" v-if="userExam">
    <div class="main-left">
      <div class="main-left_countdown">
        <exam-countdown-card
          :endTime="endTime"
          :answerList="answerList"
          @timeout="handleTimeout"
        ></exam-countdown-card>
      </div>
      <div class="main-left_answerSheet">
        <exam-answer-sheet
          :questionList="questionList"
          :answerList="answerList"
          :selectedIndex="selectedIndex"
          @change="handleQuestionChange"
          @submit="handleSubmitClick"
        ></exam-answer-sheet>
      </div>
    </div>
    <div class="question-card">
      <div class="question-card_hd">
        <div class="header-left"><span class="serial-number">{{`${selectedIndex+1}`.padStart(2, 0)}}</span><span class="title">{{curQuestion?.questionType | formatQuestionType}}</span></div>
      </div>
      <div class="question-card_bd">
        <div class="question-card_bd-question">
          <exam-question
            :question="curQuestion"
            :key="selectedIndex"
            :user-answer="answerList[selectedIndex].submitPayload"
            @submitQuestion="handleAnswerSave"
          ></exam-question>
        </div>
      </div>
      <div class="button-wrap">
        <button v-if="selectedIndex > 0" class="button prev-question" @click="handleQuestionChange(selectedIndex-1)">上一题</button>
        <button v-if="selectedIndex < questionList.length - 1" class="button next-question" @click="handleQuestionChange(selectedIndex+1)">下一题</button>
      </div>
    </div>
  </div>
  <base-modal
    v-if="successModalShow && userExam"
    class="successModal"
    :show-close="false"
    headImgUrl="https://pandapub.nosdn.127.net/tmp1753354118_f4zp3cixbujneqkjoxyn9q%3D%3D_2_1753350518_6.png"
    ok-text="知道了"
    title="恭喜你完成考试"
    @ok="goPaperPage"
  >
    <div class="successModal_content" slot="content">考试成绩将于{{ userExam.releaseResultTime | formatTime }}公布</div>
  </base-modal>
  <base-modal
    v-if="modalConfig.show"
    class="submitModal"
    :headImgUrl="modalConfig.headImgUrl"
    :show-close="false"
    :cancel-text="modalConfig.cancelText"
    :ok-text="modalConfig.okText"
    @ok="modalConfig.handleOk"
    @cancel="modalConfig.handleCancel"
    :title="modalConfig.title">
    <div class="submitModal_content" v-html="modalConfig.content" slot="content"></div>
  </base-modal>
  </div>
</template>

<script>
import { answerExamQuestion, getExamDetail, startExam, submitExam } from '@/api/qzStudent';
import { getParamByName } from '@/common/js/util';
import ExamHeader from '@/components/examHeader.vue';
import { QuestionTypeMap } from '@/common/constant/qz';
import ExamAnswerSheet from './components/examAnswerSheet.vue';
import ExamCountdownCard from './components/examCountdownCard.vue';
import ExamQuestion from './components/examQuestion.vue';
import BaseModal from '@/components/baseModal.vue';
import { reportEvent } from '@/common/js/track';
import dayjs from 'dayjs';

export default {
  name: 'PaperList',
  components: {
    BaseModal,
    ExamHeader,
    ExamCountdownCard,
    ExamQuestion,
    ExamAnswerSheet,
  },
  data: () => {
    return {
      userExam: null,
      endTime: null,
      questionList: [],
      answerList: [],
      savedList: [],
      selectedIndex: 0,
      isSubmit: false,
      isTimeout: false,
      successModalShow: false,
      modalConfig: {
        show: false,
        title: '',
        content: '',
        cancelText: '',
        okText: '',
        handleOk: () => {},
        handleCancel: () => {},
      }
    }
  },
  computed: {
    curQuestion() {
      return this.questionList[this.selectedIndex];
    },
  },
  filters: {
    formatQuestionType(type) {
      return QuestionTypeMap[type] || '';
    },
    formatTime(time) {
      return time ? dayjs(time).format('YYYY年M月D日 HH:mm') : '';
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    sortQuestions(list) {
      // 按照题目类别排序
      const typeMap = list.reduce((acc, cur) => {
        if (acc[cur.questionType]) {
          acc[cur.questionType].push(cur);
        } else {
          acc[cur.questionType] = [cur];
        }
        return acc;
      }, {});
      return Object.values(typeMap).flat();
    },
    getDetail() {
      const userExamId = getParamByName('id'); // 继续考试时使用
      const examId = getParamByName('examId'); // 试卷id，首次进入考试时使用
      const roundId = getParamByName('roundId'); // 考试场次id，首次进入考试时使用
      if (userExamId) {
        getExamDetail(userExamId).then((res) => { // 继续考试
          if (res?.code === 200) {
            this.handleExamData(res.body, false);
            this.initSelectedIndex();
          } else {
            throw res;
          }
        }).catch((res) => {
          console.error('get exam error', res)
          if (res?.code === 150001) {
            this.$message.error('请勿重复参加考试');
            this.goPaperPage();
            return;
          }
          this.$message.error(res?.message || '获取考试详情失败');
        });
      } else {
        startExam({
          courseExamId: examId,
          roundId: roundId,
          uniqueId: Math.random().toString(36).substring(2, 15),
        }).then((res) => { // 开始考试
          if (res?.code === 200) {
            this.handleExamData(res.body, true);
          } else {
            throw res;
          }
        }).catch((res) => {
          if (res?.code === 150001) {
            this.$message.error('请勿重复参加考试');
            this.goPaperPage();
            return;
          }
          console.error('get exam error', res)
          this.$message.error(res?.message || '获取考试详情失败');
        });
      }
    },
    // 统一处理接口返回数据
    handleExamData(data, isStartExam = false) {
      if (!data?.userExam) {
        this.$message.error('获取考试详情失败');
        return;
      }
      const rule = data.rule;
      const userExam = data.userExam;
      // 题目列表字段名不同
      const questionListRaw = data.userQuestions || data.question || [];
      this.userExam = userExam;

      const questionList = this.sortQuestions(questionListRaw);
      this.answerList = questionList.map(item => ({
        submitPayload: item.submitPayload || {},
      }));
      this.savedList = new Array(questionList.length).fill(true);

      const startTime = userExam.formalStartTime || userExam.startTime;
      this.endTime = startTime + (rule.costTime || 60) * 60 * 1000;

      this.questionList = this.formatQuestions(questionList, rule);

      // 仅首次进入考试时需要更新url
      if (isStartExam) {
        this.$router.replace({
          name: 'paperDetail',
          query: {
            id: userExam.id
          }
        });
      }
    },
    initSelectedIndex() {
      const answerInfo = JSON.parse(sessionStorage.getItem('qzExam-answerInfo'));
      if (answerInfo) {
        this.selectedIndex = answerInfo.selectedIndex;
        return;
      } else {
        const firstUnansweredIndex = this.answerList.findIndex(item => {
          const { submitPayload } = item;
          return !(submitPayload?.submitOption?.length || submitPayload?.pics?.length) ;
        });
        if (firstUnansweredIndex !== -1) {
          this.selectedIndex = firstUnansweredIndex;
        }
      }
    },
    formatQuestions(data, rule) {
      const ruleList = rule.intervals.sort((a, b) => a.start - b.start);
      ruleList.forEach(interval => {
        for (let i = interval.start - 1; i < interval.end; i++) {
          if (data[i]) {
            data[i].score = interval.score;
            data[i].start = interval.start;
            data[i].end = interval.end;
          }
        }
      })
      return data;
    },
    // 自动提交试卷
    handleTimeout() {
      this.isTimeout = true;
      if (this.isSubmit) return;
      this.saveAllUnSavedAnswers();
      this.submitPaper(() => {
        this.modalConfig = {
          show: true,
          headImgUrl: 'https://pandapub.nosdn.127.net/tmp1732001966_vfswlg445xrv5xkweyfdlg%3D%3D_2_1731998366_84.png',
          title: '时间已经到了哦',
          content: '<p>已自动帮您提交目前作答的所有题目</p>',
          cancelText: '',
          okText: '知道了',
          handleOk: () => {
            // this.goPaperPage()
            this.modalConfig.show = false;
            this.successModalShow = true;
          },
          handleCancel: () => {}
        }
      }, () => {
        this.$message.warning('自动交卷失败，请手动提交试卷')
      })
    },
    goPaperPage() {
      this.$router.replace({
        name: 'paperList',
      })
    },
    handleQuestionChange(index) {
      this.saveAllUnSavedAnswers();
      if (index < 0 || index >= this.questionList.length) return;
      this.selectedIndex = index;
      sessionStorage.setItem('qzExam-answerInfo', JSON.stringify({
        selectedIndex: index,
      }))
    },
    handleAnswerSave(data) {
      if (this.isTimeout) {
        this.$message.warning('答题时间已到，不可再修改')
        return;
      }

      this.answerList.splice(this.selectedIndex, 1, data);
      this.savedList.splice(this.selectedIndex, 1, false);
      this.doSaveAnswer(data, this.selectedIndex);
    },
    doSaveAnswer(data, curIndex) {
      const question = this.questionList[curIndex];
      answerExamQuestion({
        questionId: question.courseExamInstanceQuestionId || question.id,
        userCourseExamRelationInstanceId: this.userExam.id,
        ...data,
      }).then((res) => {
        if (res?.body?.result) {
          this.savedList.splice(curIndex, 1, true);
        }
      }).catch((res) => {
        if (res?.code === 150001) {
          this.$message.error('您已提交试卷，不可再修改');
          this.goPaperPage();
        }
      })
    },
    // 重新保存所有未保存的答题数据
    saveAllUnSavedAnswers() {
      console.log('saveAllUnSavedAnswers ......')
      // 遍历 savedList，找到未保存的题目
      this.savedList.forEach((saved, idx) => {
        if (!saved && this.answerList[idx]) {
          // 调用保存方法
          reportEvent('retry-submit-question', {
            questionId: this.questionList[idx].id,
            data: JSON.stringify(this.answerList[idx]),
          })
          this.doSaveAnswer(this.answerList[idx], idx);
        }
      });
    },
    submitPaper(cb, errorCb, finallyCb) {
      this.isSubmit = true;
      submitExam(this.userExam.id).then((res) => {
        if (res?.code === 200 && res.body.result) {
          cb?.();
        } else {
          errorCb?.();
        }
      }).catch((e) => {
        if (e?.code === 150001) {
          this.$message.error('您已提交试卷，不可再修改');
          this.goPaperPage();
        } else {
          errorCb?.();
        }
      }).finally(() => {
        this.isSubmit = false;
        finallyCb?.();
      });
    },
    handleSubmitClick() {
      this.saveAllUnSavedAnswers();
      const hasDone = this.answerList.every((item) => {
        const { submitPayload } = item;
        return submitPayload?.submitOption?.length > 0 || submitPayload?.pics?.length > 0;
      });
      this.modalConfig = {
        show: true,
        title: hasDone ? '提交确认' : '题目未答完',
        content: hasDone ? '提交后，所有题目不可再修改' : '您还有题目未答完，<br/>提交后，所有题目不可再修改',
        cancelText: '我再想想',
        okText: '确认提交',
        handleOk: () => {
          const submittingMsg = this.$message({
            message: '正在提交试卷...',
            duration: 0,
          })
          this.submitPaper(() => {
            this.modalConfig.show = false;
            this.successModalShow = true;
          }, () => {
            this.$message.warning('提交试卷失败，请尝试刷新页面重新提交')
          }, () => {
            submittingMsg.close();
          })
        },
        handleCancel: () => {
          this.modalConfig.show = false;
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.paperDetail {
  background: #EDE4DA;
  height: 100%;
  min-width: 1200px;
  box-sizing: border-box;
  padding-top: 72px;
  padding-bottom: 16px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  &-desc {
    width: 1200px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, .5);
    border-radius: 12px;
    padding: 16px 32px;
    color: #4E5969;
    font-size: 14px;
    line-height: 1.5;
    margin-top: 16px;
    flex: 0;
    text-align: left;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 14px;
      background: #BD9F68;
      margin-right: 5px;
      border-radius: 90px;
      vertical-align: middle;
    }
  }
  .main {
    flex: 1;
    overflow: hidden;
    margin-top: 16px;
    display: flex;
    align-items: stretch;
    justify-content: center;
    &-left {
      width: 292px;
      margin-right: 16px;
      display: flex;
      flex-direction: column;
      &_countdown {
        margin-bottom: 16px;
      }
      &_answerSheet {
        flex: 1;
        overflow: hidden;
      }
    }
    .question-card {
      width: 892px;
      // min-height: 588px;
      // max-height: calc(100vh - 120px);
      height: 100%;
      box-sizing: border-box;
      background: #fff;
      border-radius: 20px;
      padding: 36px 40px 40px;
      display: flex;
      flex-direction: column;
      &_hd {
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        padding-bottom: 22px;
        border-bottom: 1px solid #0000001A;
        .header-left {
          display: flex;
          align-items: center;
          .serial-number {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            margin-right: 8px;
            background-color: #F5F6F9;
            color: #040404E5;
            font-size: 13px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .title {
            font-size: 18px;
            font-weight: 500;
            color: #000000E5;
            line-height: 1.5;
          }
        }
      }
      &_bd {
        flex: 1;
        // max-height: calc(100vh - 340px);
        overflow-y: scroll;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        &-question {
          flex: 1;
        }
      }
    }
    .button-wrap {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      .button {
        user-select: none;
        width: 140px;
        height: 40px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 90px;
        &.prev-question {
          background: #F2F3F5;
          color: #1D2129;
          margin-right: 24px;
        }
        &.next-question {
          background: #E60012;
          color: #FFFFFF;
        }
      }
    }
  }
  .submitModal_content {
    margin-top: 4px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.5;
    color: #4E5969;
    font-size: 18px;
  }
}
</style>
<style lang="less">
  .successModal.base-modal {
    .base-modal_cnt {
      width: 478px;
      background: linear-gradient(180deg, #FFE9B5 4.29%, #FFFAEE 100%);
    }
    .base-modal_head-icon {
      width: 286px;
      height: 214px;
      margin-top: -145px;
    }
    .base-modal_title {
      margin-top: -40px;
    }
    .base-modal_btn {
      width: 240px;
    }
    .successModal_content {
      background: #FFFFFF;
      border-radius: 16px;
      height: 118px;
      width: 422px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #4E5969;
      font-size: 20px;
    }
  }
</style>
